import ChevronCircleIcon from './ChevronCircleIcon';

export default ChevronCircleIcon;
